import Vue from 'vue'

export default {
  toggleEditMode: (state) => state.isEditMode = !state.isEditMode,
  setPageProperties: (state, properties) => state.pageProperties = properties,
  setCampaignId: (state, campaignId) => state.campaignId = campaignId,
  pageBuilderSelectField: (state, selected) => state.pageBuilder.selectedField = selected,
  setComponentStatus: (state, { component, status }) => Vue.set(state.componentStatus, component, status),
  setField: (state, { field, value }) => Vue.set(state, field, value),
  setStep: (state, { pageStatus }) => state.pageStatus = pageStatus,
  setReceiptToken: (state, receiptToken ) => state.receiptToken = receiptToken,
  setSerial: (state, serial) => state.serial = serial,
  setSurveyResult: (state, surveyResult) => state.surveyResult = surveyResult,
  setModelNumber: (state, modelNumber) => state.modelNumber = modelNumber,
  setReferenceNumber: (state, data) => state.referenceNumber = data,
  setCustomerToken: (state, data) => state.customerToken = data,
  setHostCountry: (state, data) => state.hostCountry = data,
  setUploadPercentage: (state, data) => state.uploadPercentage = data,
  setSignedUp: (state, data) => state.signedUp = data,
  setUserType: (state, data) => state.userType = data,
  setModalOptions: (state, { message = 'An error occured', type = 'error', isActive, closeButton = false }) => {
    state.modal.message = message;
    state.modal.type = type;
    state.modal.isActive = isActive;
    state.modal.closeButton = closeButton;
  }
}